<div>
	<app-dropdown-columns-actions
		[columns]="columns()"
		[translationPrefix]="'portfolioBlocks.'"
		[isDraggable]="false"
		(columnsChange)="onChangeColumns($event)"
	/>
</div>
